/**
 * Política de privacidad — **contenido provisorio**.
 *
 * ⚠️ **Esto es un armazón, no el texto legal.** Existe porque el banner de
 * cookies necesita un destino real: sin él, quien quisiera informarse antes de
 * aceptar se topaba con un enlace muerto —o con nada—, que es justo lo que el
 * consentimiento informado debería evitar.
 *
 * 🔴 **El texto definitivo lo redacta quien corresponda, no el equipo de
 * desarrollo.** Los apartados de abajo describen, con honestidad, lo que la
 * tienda hace hoy; **no son una declaración legal** y no deberían publicarse
 * como tal. La página avisa de esto en pantalla, en vez de aparentar una
 * política que nadie revisó: un aviso legal falso es peor que uno pendiente.
 */
export function PrivacyPolicyPage(): JSX.Element {
  return (
    <section className="container-fc py-12">
      <div className="mx-auto max-w-2xl">
        <h1 className="font-display text-3xl">Política de privacidad</h1>

        {/*
          El aviso va ARRIBA, antes del contenido: quien llegue debe saber que
          esto todavía no es el documento definitivo antes de leerlo, no después.
        */}
        <div
          role="note"
          className="mt-6 rounded-card border border-fc-line bg-fc-paper p-4 text-sm text-fc-muted"
        >
          <strong className="text-fc-ink">Documento en preparación.</strong> El texto legal
          definitivo está en elaboración. Lo que sigue describe cómo funciona la tienda hoy, para
          que puedas decidir con información, pero todavía no reemplaza a la política formal.
        </div>

        <div className="mt-8 flex flex-col gap-6 text-fc-ink">
          <div>
            <h2 className="font-display text-xl">Qué guardamos en tu navegador</h2>
            <p className="mt-2 text-fc-muted">
              Guardamos tu decisión sobre las cookies para no volver a preguntarte en cada visita, y
              los datos necesarios para mantener tu sesión abierta y conservar tu carrito mientras
              comprás. Podés revisar tu decisión sobre cookies desde el enlace{' '}
              <span className="text-fc-ink">Preferencias de cookies</span>, al pie de la página.
            </p>
          </div>

          <div>
            <h2 className="font-display text-xl">Qué datos nos das al registrarte</h2>
            <p className="mt-2 text-fc-muted">
              Al crear una cuenta te pedimos nombre, correo, teléfono y fecha de nacimiento. Los
              usamos para identificarte, emitir tus boletas y comunicarnos con vos sobre tus
              compras.
            </p>
          </div>

          <div>
            <h2 className="font-display text-xl">Tus derechos</h2>
            <p className="mt-2 text-fc-muted">
              Podés consultar y corregir tus datos desde tu cuenta, y pedir que los eliminemos
              escribiéndonos. El detalle de plazos y del procedimiento queda definido en el
              documento formal.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
